import React from 'react'
import { useSelector } from 'react-redux'
import { Environments } from 'src/configurations'
import { selectEnvironmentFromState } from 'src/redux/selectors/session.selectors'

const SignupCMS: React.FC = () => {
  const env = useSelector(selectEnvironmentFromState)
  const url =
    env === Environments.Prod
      ? 'http://static.paywithextend.com/index.html'
      : 'https://static-stage.paywithextend.com/index.html'

  return <iframe src={url} height="100%" width="100%" title="signup" />
}

export default SignupCMS
